import { render } from "./OltpGraphVisualizer.vue?vue&type=template&id=2a55effd&scoped=true"
import script from "./OltpGraphVisualizer.vue?vue&type=script&lang=js"
export * from "./OltpGraphVisualizer.vue?vue&type=script&lang=js"

import "./OltpGraphVisualizer.vue?vue&type=style&index=0&id=2a55effd&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a55effd"]])

export default __exports__